const CRAWLER_USER_AGENTS = /WhatsApp|Facebook|Twitterbot|LinkedInBot|TelegramBot|Slack|Discord|Pinterest|Googlebot/i;

const DEFAULT_SITE_URL = 'https://www.7cantos.com';
const ROBOTS_INDEX = 'index, follow';
const ROBOTS_NOINDEX = 'noindex, follow';

const CITY_QUERY_KEYS = new Set(['city', 'UF', 'uf']);

const INDEXABLE_CITIES = [
  { city: 'Fortaleza', uf: 'CE' },
  { city: 'Recife', uf: 'PE' },
  { city: 'Aquiraz', uf: 'CE' },
  { city: 'Caucaia', uf: 'CE' },
];

const STATIC_PAGES = {
  '/': {
    title: '7Cantos | Imobiliária de aluguel em Fortaleza',
    description: 'Imobiliária de aluguel residencial em Fortaleza. Encontre ou anuncie apartamentos e casas na 7Cantos.',
    heading: 'Alugue rápido, anuncie de forma simples!',
    paragraph: 'Descubra a maneira mais eficiente de alugar e anunciar imóveis.',
    includeHomeFaq: true,
  },
  '/about-us': {
    title: 'Sobre a 7Cantos | Imobiliária de aluguel',
    description: 'A 7Cantos é uma imobiliária de aluguel com atuação em Fortaleza, Juazeiro do Norte e Recife.',
    heading: 'Imobiliária de aluguel em Fortaleza',
    paragraph: 'A 7Cantos aluga imóveis residenciais em Fortaleza, Juazeiro do Norte e Recife, com atendimento online para proprietários e inquilinos.',
  },
  '/anunciar-imovel': {
    title: 'Anunciar imóvel para aluguel | 7Cantos',
    description: 'Anuncie seu imóvel para aluguel na 7Cantos. Fotos, análise de crédito e contrato sem fidelidade.',
    heading: 'Anunciar imóvel para aluguel',
    paragraph: 'Anuncie seu imóvel residencial para aluguel com a 7Cantos e receba interessados sem burocracia.',
  },
  '/use-terms': {
    title: 'Termos de uso | 7Cantos',
    description: 'Termos de uso da plataforma 7Cantos para anúncio e aluguel de imóveis.',
    heading: 'Termos de uso',
    paragraph: 'Termos de uso da 7Cantos, plataforma de aluguel de imóveis residenciais.',
  },
  '/privacy-politics': {
    title: 'Política de privacidade | 7Cantos',
    description: 'Política de privacidade da 7Cantos sobre o uso de dados na plataforma de aluguel.',
    heading: 'Política de privacidade',
    paragraph: 'Como a 7Cantos trata os dados de quem anuncia ou aluga um imóvel.',
  },
};

function firstQueryValue(value) {
  if (Array.isArray(value)) {
    return firstQueryValue(value[0]);
  }
  if (value == null) {
    return '';
  }
  return String(value).trim();
}

function normalizePath(pathname) {
  const raw = String(pathname || '/').split('?')[0];
  let path = raw;
  try {
    path = decodeURIComponent(raw);
  } catch (error) {
    path = raw;
  }
  if (path.length > 1 && path.endsWith('/')) {
    path = path.slice(0, -1);
  }
  return path || '/';
}

function siteBase(siteUrl) {
  return String(siteUrl || DEFAULT_SITE_URL).replace(/\/$/, '');
}

function findIndexableCity(city, uf) {
  const cityKey = city.toLowerCase();
  const ufKey = uf.toLowerCase();
  return INDEXABLE_CITIES.find((entry) => entry.city.toLowerCase() === cityKey && entry.uf.toLowerCase() === ufKey) || null;
}

function hasExtraSearchParams(query) {
  return Object.keys(query || {}).some((key) => {
    if (CITY_QUERY_KEYS.has(key)) {
      return false;
    }
    return firstQueryValue(query[key]) !== '';
  });
}

function citySearchUrl(base, city, uf) {
  return `${base}/search?city=${encodeURIComponent(city)}&UF=${encodeURIComponent(uf)}`;
}

function searchProfile(title, description, canonicalUrl, robots, heading, paragraph) {
  return { title, description, canonicalUrl, robots, heading, paragraph };
}

function resolveSearchSeo(query, base) {
  const city = firstQueryValue(query.city);
  const uf = firstQueryValue(query.UF) || firstQueryValue(query.uf);
  const match = city && uf ? findIndexableCity(city, uf) : null;
  const extra = hasExtraSearchParams(query);

  if (match) {
    const place = match.city;
    return searchProfile(
      `Imóveis para alugar em ${place} | 7Cantos`,
      `Apartamentos e casas para alugar em ${place} com a imobiliária 7Cantos.`,
      citySearchUrl(base, match.city, match.uf),
      extra ? ROBOTS_NOINDEX : ROBOTS_INDEX,
      `Imóveis para alugar em ${place}`,
      `Veja imóveis residenciais para alugar em ${place} na 7Cantos.`
    );
  }

  if (city && uf) {
    return searchProfile(
      `Imóveis para alugar em ${city} | 7Cantos`,
      `Busca de imóveis para alugar em ${city}. Esta combinação não faz parte das cidades indexadas da 7Cantos.`,
      citySearchUrl(base, city, uf),
      ROBOTS_NOINDEX,
      `Imóveis para alugar em ${city}`,
      `Busca de imóveis para alugar em ${city}.`
    );
  }

  return searchProfile(
    'Busca de imóveis para alugar | 7Cantos',
    'Busca de imóveis para alugar na 7Cantos. Escolha uma cidade para ver os anúncios.',
    `${base}/`,
    ROBOTS_NOINDEX,
    'Busca de imóveis para alugar',
    'Escolha uma cidade para ver imóveis residenciais para alugar na 7Cantos.'
  );
}

function resolvePublicSeo(pathname, query, siteUrl) {
  const path = normalizePath(pathname);
  const base = siteBase(siteUrl);
  if (path === '/search') {
    return resolveSearchSeo(query || {}, base);
  }
  const page = STATIC_PAGES[path];
  if (!page) {
    return null;
  }
  // NOTE: object spread makes the production Babel build inject an ESM helper import,
  // which turns this CommonJS module (also required by server.js) into a mixed module
  // with no detectable exports.
  return Object.assign({}, page, {
    canonicalUrl: `${base}${path === '/' ? '/' : path}`,
    robots: ROBOTS_INDEX,
  });
}

const { applySeoToHtml } = require('./applySeoToHtml');

module.exports = {
  CRAWLER_USER_AGENTS,
  resolvePublicSeo,
  applySeoToHtml,
};
